import { PartBomDetailsTab } from './enums';
import { fullScreenStyle, largeWrapperStyle, smallWrapperStyle } from './style';

export const getTabStyle = (
  tabValue: PartBomDetailsTab,
  { fullScreen = false, inline = false }: { fullScreen?: boolean; inline?: boolean } = {}
) => {
  switch (tabValue) {
    case PartBomDetailsTab.PART_DETAILS:
      if (inline) {
        return { maxWidth: '400px' };
      }

      return fullScreen ? fullScreenStyle : smallWrapperStyle;
    case PartBomDetailsTab.ITEM_LIST:
      if (inline) {
        return { width: 'inherit' };
      }

      return fullScreen ? fullScreenStyle : largeWrapperStyle;
    default:
      return {};
  }
};
